import { useCallback, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import apiFetch from '../../../utils/apiFetch';
export const lootChanged = campaignId => window.dispatchEvent(new CustomEvent('realmtracker:loot-changed', { detail: { campaignId } }));
export const lootId = () => window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
export async function lootRequest(url, body, method = 'POST') {
  const response = await apiFetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  const result = await response.json();
  if (!response.ok) throw Object.assign(new Error(result.message || 'Unable to update loot.'), { status: response.status });
  return result;
}
export default function useLoot(campaignId, characterId, isDm) {
  const [state, setState] = useState({ data: null, error: '', loading: false });
  const sequence = useRef(0);
  const endpoint = `/campaigns/${encodeURIComponent(campaignId || '')}/loot`;
  const reload = useCallback(async () => {
    if (!campaignId || !isDm && !characterId) return;
    const version = ++sequence.current;
    setState(s => ({ ...s, loading: true }));
    try {
      const response = await apiFetch(`${endpoint}${isDm ? '' : `?characterId=${encodeURIComponent(characterId)}`}`, { cache: 'no-store' });
      const data = await response.json(); if (!response.ok) throw new Error(data.message || 'Unable to load loot.');
      if (!data || !Array.isArray(data.pools) || isDm && !Array.isArray(data.characters)) throw new Error('Unexpected loot response. Refresh to try loading your saved pools again.');
      if (version === sequence.current) setState({ data, error: '', loading: false });
    } catch (err) { if (version === sequence.current) setState(s => ({ ...s, error: err.message, loading: false })); }
  }, [campaignId, characterId, isDm, endpoint]);
  useEffect(() => {
    setState({ data: null, error: '', loading: false }); reload();
    if (!campaignId || !isDm && !characterId) return undefined;
    const socket = io(process.env.REACT_APP_API_URL || undefined, { withCredentials: true });
    socket.on('connect', () => { socket.emit('campaign:join', campaignId); reload(); });
    socket.on('campaign:loot:update', reload);
    const changed = e => { if (e.detail?.campaignId === campaignId) reload(); };
    window.addEventListener('realmtracker:loot-changed', changed);
    window.addEventListener('focus', reload);
    const timer = window.setInterval(reload, 30000);
    return () => { sequence.current++; socket.disconnect(); clearInterval(timer); window.removeEventListener('realmtracker:loot-changed', changed); window.removeEventListener('focus', reload); };
  }, [campaignId, characterId, isDm, reload]);
  return { ...state, endpoint, reload };
}
